module.exports = __webpack_public_path__ + "media/images/icons/illustration_covid-c2cf8ff37d1d0d96903fc54b34f8137b.svg";